export default status => {
  if (status === 'POS') {
    return 'POS';
  } if (status === 'PAYMENT_GATEWAY') {
    return 'Online Payment Gateway';
  } return 'POS';
};
